import { Action } from "@ngrx/store";
import { ISupportAction } from "../../models/support-action";

export const RESET_STATE = "[support] ResetState";
export const ADD = "[support] Add";
export const REPLACE = "[support] Replace";
export const UPDATE = "[support] Update";
export const DELETE = "[support] Delete";
export const REPLACE_MULTIPLE = "[support] Replace multiple";

/**
 * Every action is comprised of at least a type and an optional
 * payload. Expressing actions as classes enables powerful
 * type checking in reducer functions.
 *
 * See Discriminated Unions: https://www.typescriptlang.org/docs/handbook/advanced-types.html#discriminated-unions
 */
export class ResetStateAction implements Action {
  readonly type = RESET_STATE;
  constructor(public payload?: ISupportAction) {}
}

export class AddAction implements Action {
  readonly type = ADD;
  constructor(public payload: ISupportAction) {}
}

export class ReplaceAction implements Action {
  readonly type = REPLACE;
  constructor(public payload: ISupportAction) {}
}

export class ReplaceMultipleAction implements Action {
  readonly type = REPLACE_MULTIPLE;
  constructor(public payload: ISupportAction[]) {}
}

export class UpdateAction implements Action {
  readonly type = UPDATE;
  constructor(public payload: ISupportAction) {}
}

export class DeleteAction implements Action {
  readonly type = DELETE;
  constructor(public payload: { id: string }) {}
}

/**
 * Export a type alias of all actions in this action group
 * so that reducers can easily compose action types
 */
export type Actions =
  | ResetStateAction
  | AddAction
  | ReplaceAction
  | ReplaceMultipleAction
  | UpdateAction
  | DeleteAction;



// WEBPACK FOOTER //
// ./src/app/store/actions/support-action.actions.ts